<template>
  <div class="search">
    <div class="phone" v-show="!isPc">
      <div v-for="(item, index) in inputArr" :key="'phone' + index">
        <p :class="currentFocus && currentFocus == index + 1 ? 'active' : ''">
          {{ item.name }}<span class="red">*</span>
        </p>
        {{ item.model }}
        <input
          type="text"
          :class="currentFocus && currentFocus == index + 1 ? 'active' : ''"
          v-model="item.model"
          @focus="currentFocus = index + 1"
          @blur="currentFocus = ''"
        />
        <!-- <el-col v-show="isFuzzyQuery" v-for="(item,index) in queryList" :key="'phoneQuery'+index" @click.native="select(item)">{{item}}</el-col> -->
      </div>
      <button @click="back" class="btn">返回</button>
      <button @click="search" class="btn back">查询</button>
    </div>
    <div class="pc" v-show="isPc">
      <el-row>
        <el-col
          v-for="(item, index) in inputArr"
          :offset="index % 2 == 0 ? 0 : 2"
          :key="'pc' + index"
        >
          <p :class="currentFocus && currentFocus == index + 1 ? 'active' : ''">
            {{ item.name }}<span class="red">*</span>
          </p>
          <input
            type="text"
            :class="currentFocus && currentFocus == index + 1 ? 'active' : ''"
            v-model="item.model"
            @focus="currentFocus = index + 1"
            @blur="currentFocus = ''"
          />
        </el-col>
        <el-col
          v-show="isFuzzyQuery"
          v-for="(item, index) in queryList"
          :key="'pcQuery' + index"
          @click.native="select(item)"
          >{{ item }}</el-col
        >
      </el-row>
      <!-- <p>请输入查询码</p>
        <el-row :gutter="20">
            <el-col :span="4" v-for="(item,index) in arr" :key="'pc_'+index"><input type="number" class="input" maxlength="1" v-model="item.model" :ref="'pcinput'+index" @keyup="change(index,'pc')"></el-col>
        </el-row> -->
      <el-row>
        <el-col :span="4" :offset="6"
          ><button @click="back" class="btn">返回</button></el-col
        >
        <el-col :span="4" :offset="3"
          ><button @click="search" class="btn">查询</button></el-col
        >
      </el-row>
    </div>
  </div>
</template>
<script>
import { Decrypt } from '../plugs/aes-utils';
export default {
  name: "search",
  data() {
    return {
      isPc: false,
      code: "123456",
      currentFocus: "",
      arr: [
        { model: "" },
        { model: "" },
        { model: "" },
        { model: "" },
        { model: "" },
        { model: "" },
      ],
      inputArr: [{ name: "车架号", model: "" }], // 去掉查询码 车架后6位改为车架号
      isFuzzyQuery: false,
      queryList: [],
    };
  },
  methods: {
    search() {
      let that = this;
      if (!this.inputArr[0].model) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请输入车架号")
          : this.$root.$children[0].vueAlert("请输入车架号");
      }
      if (this.inputArr[0].model.length !== 17) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("车架号长度为17位")
          : this.$root.$children[0].vueAlert("车架号长度为17位");
      }
      let params = {
        clsbdh: this.inputArr[0].model,
        // "cxm": this.inputArr[0].model
      };
      this.$parent.showLoading();
      this.$post("fLow/queryByCode", params).then((response) => {
        that.$toast.clear();
        if (response.status != "1" && response.status != "2") {
          if (that.isPc) {
            return that.$root.$children[0].vueAlert1(response.msg);
          } else {
            return that.$root.$children[0].vueAlert(response.msg);
          }
        }
        // 解密response.data后再保存到localStorage
        const decryptedData = Decrypt(response.data);
        localStorage.setItem("searchResult", JSON.stringify(decryptedData));
        this.$router.push("result1");
      });
    },
    // 改变焦点
    change(index, des) {
      let i = index + 1;
      let j = index - 1;
      if (this.arr[index].model) {
        if (index > 4) {
          return;
        }
        this.$refs[des + "input" + i][0].focus();
      } else {
        if (j < 0) {
          return;
        }
        this.$refs[des + "input" + j][0].focus();
      }
      console.log(this.arr[index].model);
    },
    // 模糊查询（只能提示
    // fuzzyQuery(item){
    //   // console.log(item)
    //   let that = this
    //   let params = {
    //     "clsbdh":item
    //   }
    //   if(item&&item.length>=5){
    //     this.isFuzzyQuery =true
    //     that.$get("fLow/cjhlb",params).then(response=>{
    //       // console.log(response.data)
    //       if(response.status != "1"){
    //         if(that.isPc){
    //           return that.$root.$children[0].vueAlert1(response.msg);
    //         }else{
    //           return that.$root.$children[0].vueAlert(response.msg);
    //         }
    //       }
    //       this.queryList = response.data
    //     })
    //   }
    //   if(!item||item.length<5){
    //     this.isFuzzyQuery = false
    //   }
    // },
    select(item) {
      // console.log(item)
      this.inputArr[0].model = item;
      this.isFuzzyQuery = false;
    },
    back() {
      window.history.go(-1);
    },
  },
  mounted() {
    this.isPc = window.innerWidth > 640 ? true : false;
    // console.log(this.isPc)
  },
};
</script>
<style scoped>
.search {
  text-align: left;
}
.phone {
  position: relative;
  height: 84vh;
  padding: 10vh 5vw 4vh 5vw;
}
p {
  line-height: 5vh;
}
input {
  width: 100%;
  line-height: 6vh;
  background: none;
  border: none;
  outline: none;
  color: rgb(198, 203, 212);
  border-bottom: 1px solid rgb(198, 203, 212);
  font-size: 16px;
  text-indent: 5px;
}
/* .input{
    width: 100%;
    margin-top: 10vh;
    line-height: 10vh;
    font-size: 20vw;
    background: 0;
    outline: 0;
    border: 0;
    text-align: center;
    border-bottom: 4px solid rgb(221, 221, 221);
} */
.active {
  color: rgb(87, 96, 255);
}
input.active {
  color: rgb(87, 96, 255);
  border-bottom-color: rgb(87, 96, 255);
}
.pc .input {
  margin-top: 6vh;
  line-height: 8vh;
  font-size: 10vw;
}
h1 {
  font-size: 10vh;
  line-height: 24vh;
  color: rgb(0, 198, 49);
}
.phone .btn {
  width: 90vw;
  position: absolute;
  bottom: 6vh;
  left: 5vw;
}
.phone .back {
  bottom: -2vh;
}
.pc {
  width: 50vw;
  padding: 5vh;
  margin: 15vh 22.5vw;
  background: #fff;
}
.pc .btn {
  margin-top: 4vh;
}
span.red {
  color: red;
}
</style>
